module.exports = __webpack_public_path__ + "static/media/bor_logo.7e237232.png";